module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n      back to search\n    ")]), _vm._v("\n    " + _vm._s(_vm.$store.state.bio.name) + " Bio\n  ")], 1), _vm._v(" "), _c('p', {
    class: {
      'bio__content--center': _vm.centerContent
    }
  }, [(_vm.$store.state.bioImg !== '') ? _c('img', {
    staticClass: "bio__pick",
    attrs: {
      "src": _vm.$store.state.bioImg,
      "alt": _vm.$store.state.bio.name
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.bioContent)
    }
  })]), _vm._v(" "), (_vm.$store.state.similarArtist.length > 0) ? _c('aside', {
    staticClass: "similar"
  }, [_c('nav', [_c('h3', [_vm._v("Also Check out:")]), _vm._v(" "), _vm._l((_vm.$store.state.similarArtist), function(similar) {
    return _c('div', {
      on: {
        "click": function($event) {
          _vm.newArtiest(similar.name)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": ("/bio/" + (encodeURI(similar.name)))
      }
    }, [_c('img', {
      attrs: {
        "src": similar.image[3]['#text'],
        "alt": similar.name
      }
    })])], 1)
  })], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53dee918"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bio.vue
// module id = 60
// module chunks = 1